import { Client } from './Client';
import { pintail } from './index';

type PintailStub = { q?: ArrayLike<unknown> };

const existing: PintailStub | Client | undefined = (
  window as unknown as { pintail?: PintailStub | Client }
).pintail;

const queued: ArrayLike<unknown>[] =
  existing && !(existing instanceof Client) && Array.isArray(existing.q)
    ? (existing.q as ArrayLike<unknown>[])
    : [];

window.pintail = pintail;

type TrackArgs = Parameters<Client['track']>;
for (const args of queued) {
  void pintail.track(...(Array.from(args) as unknown as TrackArgs));
}
